import React from 'react';
import { BasicTable } from './BasicTable/BasicTable';

const ManageDeliverySlotsComponent: React.FC = () => {
    return (
        <>
            <div style={{ marginBottom: '20px', flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                <h4 style={{ fontWeight: 'bold' }}>Delivery Slots</h4>
            </div>
            <BasicTable />
        </>
    );
};

export default ManageDeliverySlotsComponent;
